export const logs = {
  log_wire_sched: "log_wire_sched",
  log_vpn_service: "log_wire_sched_vpn",
};

export default logs;
